import AOS from 'aos';

export default (() => {
    AOS.init();

    let pageHeight = document.body.getBoundingClientRect().height;

    // Refresh positions of AOS elements when imgs load in and change page height.
    window.setInterval(() => {
        const newHeight = document.body.getBoundingClientRect().height;
        if (newHeight !== pageHeight) {
            AOS.refresh();
            pageHeight = newHeight;
        }
    }, 1000);
})();
